import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Vista from './layout/Vista';
import RubricaFilterBar from './chiama_e_inoltra/FilterBar';
import ContactListRow from './chiama_e_inoltra/ListRow';
import { chiamaEInoltra } from '../api';
import { showError } from '../utils';
import useAlert from '../hooks/useAlert';


export default function ChiamaEInoltra({ initialSearchterm = '' }) {
    const navigate = useNavigate();
    const [selectedContacts, setSelectedContacts] = useState([]);
    const [isLoadingInoltro, setIsLoadingInoltro] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const alert = useAlert();

    const handleSendContacts = async () => {
        if (selectedContacts.length === 0) {
            alert({message: "Nessun contatto selezionato per essere chiamato e inoltrato dalla segretaria.", type: 'error'});
            return;
        }
        setIsLoadingInoltro(true);
        try{
            await chiamaEInoltra(selectedContacts[0].id);
            alert({message: `Segretaria avvisata con successo!`});
            setRefresh(prev => !prev); // Forza il refresh della lista
        }catch(err){
            showError([err.message]);
        }finally{
            setIsLoadingInoltro(false);                
        }
        setSelectedContacts([]); // Resetta la selezione dopo l'eliminazione
        
    };

    const fullSizeActions = [
        {
            label: "Chiedi a seg. di chiamare e inoltrare il contatto" + (isLoadingInoltro ? "..." : ""),
            disabled: isLoadingInoltro || selectedContacts.length === 0,
            onClick: handleSendContacts,
        }
    ];

    return (
        <Vista
            key={refresh}
            apiCallEndpoint={"/listacontatti"}
            initialFilterParams={{ searchterm: initialSearchterm }}
            FilterBarComponent={RubricaFilterBar}
            ListRowComponent={ContactListRow}
            fullSizeActions={fullSizeActions}
            selectable={true}
            onSelectionChange={(selectedIds, selectedItems) => setSelectedContacts(selectedItems)}
            endMessage="Non ci sono altri contatti"
        />
    );
}